var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 469,
    viewBox: "0 0 365 469",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_628_2038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90531 232.381C16.5246 208.832 28.9217 187.109 45.3211 168.571L58.8506 153.244C59.3113 152.736 59.8895 152.35 60.5346 152.118C61.1797 151.886 61.8718 151.816 62.5503 151.914C63.2287 152.012 63.8727 152.275 64.4258 152.68C64.9789 153.085 65.4241 153.619 65.7224 154.236L74.4421 172.732C79.8837 184.338 88.8532 195.832 100.993 206.783C101.795 207.479 102.64 207.598 103.212 207.59C103.784 207.581 104.648 207.386 105.344 206.584C106 205.89 106.262 204.925 106.113 204.004C100.936 173.214 106.512 137.281 122.779 97.0956C136.224 63.715 156.941 36.594 184.264 16.3235L204.204 1.56916C206.81 -0.371697 210.591 1.41544 210.779 4.67499L212.255 29.505C213.265 46.472 216.798 61.1946 222.741 73.1122C230.007 87.7009 239.63 100.948 251.366 112.514C259.532 120.551 268.575 127.646 278.325 133.665C301.795 148.061 321.705 167.58 336.563 190.761C351.413 214.159 360.66 240.67 363.585 268.228C366.15 292.526 363.846 316.558 356.716 339.746C349.825 362.074 338.673 382.855 323.876 400.941C308.936 419.175 290.949 434.192 270.33 445.478C248.977 457.206 225.796 464.443 201.343 467.024C176.89 469.606 152.709 467.37 129.383 460.411C106.921 453.726 85.9754 442.73 67.7172 428.037C49.2985 413.324 34.1899 395.451 22.8224 375.049C11.0282 353.92 3.66125 330.611 1.17073 306.542C-1.48156 281.42 1.09025 256.475 8.90531 232.381Z",
    fill: "url(#paint0_linear_628_2038)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_628_2038",
    x: 0.160156,
    y: 0.765625,
    width: 364.439,
    height: 471.298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_628_2038"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_628_2038",
    result: "effect2_innerShadow_628_2038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_2038",
    x1: 177,
    y1: 124,
    x2: 177,
    y2: 486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF9CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e0cf75629fc84fc22e2c8c2aabdc71ce.svg";
export { ForwardRef as ReactComponent };